const KEY = 'mimic:playerToken';

/**
 * Token de reconnexion, propre à l'ONGLET (sessionStorage : survit au
 * rechargement, mais deux onglets = deux joueurs distincts au lieu de se voler
 * le même joueur). Envoyé au serveur via l'auth Socket.IO ; il permet de
 * retrouver son joueur après une coupure ou un rechargement. Distinct de l'id
 * public du joueur (jamais exposé aux autres).
 */
export function getPlayerToken(): string {
  try {
    let t = sessionStorage.getItem(KEY);
    if (!t) {
      t = crypto.randomUUID();
      sessionStorage.setItem(KEY, t);
    }
    return t;
  } catch {
    return crypto.randomUUID();
  }
}
